var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DefaultViewAnonymousUser',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$can('logout', 'Auth')),expression:"!$can('logout', 'Auth')"}]}),_c('DefaultViewLoggedInUser',{directives:[{name:"show",rawName:"v-show",value:(_vm.$can('logout', 'Auth')),expression:"$can('logout', 'Auth')"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }